import { FetchBase, FetchHeaders, LsFetch } from '../common/fetch';
import { handleFetchError } from '../common/handle_fetch_error';

/**
 * Apart from streaming, this browser implementation doesn't do anything
 * as proxy handling should be automatic.
 */
export class Fetch extends FetchBase implements LsFetch {
  /**
   * Browser-specific fetch implementation.
   * See https://gitlab.com/gitlab-org/editor-extensions/gitlab-lsp/-/issues/171 for details
   */
  async *streamFetch(
    url: string,
    body: string,
    headers: FetchHeaders,
  ): AsyncGenerator<string, void, void> {
    const response = await this.fetch(url, {
      method: 'POST',
      headers,
      body,
    });

    await handleFetchError(response, 'Streaming Code Suggestions');

    const reader = response?.body?.getReader();
    if (!reader) {
      return undefined;
    }

    let buffer = '';
    let readResult = await reader.read();

    while (!readResult.done) {
      // TODO: We should consider streaming the raw bytes instead of the decoded string
      const rawContent = new TextDecoder().decode(readResult.value);
      buffer += rawContent;
      // TODO if we cancel the stream, and nothing will consume it, we probably leave the HTTP connection open :-O
      yield buffer;

      // eslint-disable-next-line no-await-in-loop
      readResult = await reader.read();
    }

    return undefined;
  }
}
